// extracted by mini-css-extract-plugin
export var wordContainer = "_nh-0";